// Mappers for statistics-related entities
// Identity mappers for 1:1 mapping

import type {
  MachineStatisticsResponseDto,
  NcFileStatisticsTimesResponseDto,
  MachineStatisticsOeeTeepResponseDto,
  ProductionBatchStatisticsResponseDto,
  ProductionBatchDto,
  NcFileStatisticsResponse2Dto,
  NcFileStatisticsPaidResponseDto,
  MachineStatisticsPaidResponseDto,
  MachineStatsHourOeeTeepDto,
  MachineStatsDayOeeTeepDto,
  MachineStatsMonthOeeTeepDto,
  MachineStatsWeekOeeTeepDto,
  MachineStatsHourAllOeeTeepDto,
  MachineStatsDayAllOeeTeepDto,
  MachineStatsMonthAllOeeTeepDto,
  MachineStatsWeekAllOeeTeepDto,
  MachineEventCycleStatisticsResponseDto,
} from '../../generated/models';

import type {
  MachineStatisticsResponse,
  NcFileStatisticsTimesResponse,
  MachineStatisticsOeeTeepResponse,
  ProductionBatchStatisticsResponse,
  ProductionBatch,
  NcFileStatisticsResponse,
  NcFileStatisticsPaidResponse,
  MachineStatisticsPaidResponse,
  MachineStatsHourOeeTeep,
  MachineStatsDayOeeTeep,
  MachineStatsMonthOeeTeep,
  MachineStatsWeekOeeTeep,
  MachineStatsHourAllOeeTeep,
  MachineStatsDayAllOeeTeep,
  MachineStatsMonthAllOeeTeep,
  MachineStatsWeekAllOeeTeep,
  MachineEventCycleStatisticsResponse,
} from '../types';

// Response mappers (identity for 1:1)
export const toMachineStatisticsResponse = (dto: MachineStatisticsResponseDto): MachineStatisticsResponse => dto;
export const toNcFileStatisticsTimesResponse = (dto: NcFileStatisticsTimesResponseDto): NcFileStatisticsTimesResponse =>
  dto;
export const toMachineStatisticsOeeTeepResponse = (dto: MachineStatisticsOeeTeepResponseDto): MachineStatisticsOeeTeepResponse =>
  dto;
export const toProductionBatchStatisticsResponse = (
  dto: ProductionBatchStatisticsResponseDto
): ProductionBatchStatisticsResponse => dto;
export const toNcFileStatisticsResponse = (dto: NcFileStatisticsResponse2Dto): NcFileStatisticsResponse => dto;
export const toNcFileStatisticsPaidResponse = (dto: NcFileStatisticsPaidResponseDto): NcFileStatisticsPaidResponse =>
  dto;
export const toMachineStatisticsPaidResponse = (dto: MachineStatisticsPaidResponseDto): MachineStatisticsPaidResponse =>
  dto;
export const toMachineEventCycleStatisticsResponse = (
  dto: MachineEventCycleStatisticsResponseDto
): MachineEventCycleStatisticsResponse => dto;

// Entity mappers (identity for 1:1)
export const toProductionBatch = (dto: ProductionBatchDto): ProductionBatch => dto;
export const toProductionBatches = (dtos: ProductionBatchDto[]): ProductionBatch[] => dtos.map(toProductionBatch);

// OEE/TEEP Stats mappers (identity for 1:1)
export const toMachineStatsHourOeeTeep = (dto: MachineStatsHourOeeTeepDto): MachineStatsHourOeeTeep => dto;
export const toMachineStatsHourOeeTeeps = (dtos: MachineStatsHourOeeTeepDto[]): MachineStatsHourOeeTeep[] =>
  dtos.map(toMachineStatsHourOeeTeep);

export const toMachineStatsDayOeeTeep = (dto: MachineStatsDayOeeTeepDto): MachineStatsDayOeeTeep => dto;
export const toMachineStatsDayOeeTeeps = (dtos: MachineStatsDayOeeTeepDto[]): MachineStatsDayOeeTeep[] =>
  dtos.map(toMachineStatsDayOeeTeep);

export const toMachineStatsMonthOeeTeep = (dto: MachineStatsMonthOeeTeepDto): MachineStatsMonthOeeTeep => dto;
export const toMachineStatsMonthOeeTeeps = (dtos: MachineStatsMonthOeeTeepDto[]): MachineStatsMonthOeeTeep[] =>
  dtos.map(toMachineStatsMonthOeeTeep);

export const toMachineStatsWeekOeeTeep = (dto: MachineStatsWeekOeeTeepDto): MachineStatsWeekOeeTeep => dto;
export const toMachineStatsWeekOeeTeeps = (dtos: MachineStatsWeekOeeTeepDto[]): MachineStatsWeekOeeTeep[] =>
  dtos.map(toMachineStatsWeekOeeTeep);

export const toMachineStatsHourAllOeeTeep = (dto: MachineStatsHourAllOeeTeepDto): MachineStatsHourAllOeeTeep => dto;
export const toMachineStatsHourAllOeeTeeps = (dtos: MachineStatsHourAllOeeTeepDto[]): MachineStatsHourAllOeeTeep[] =>
  dtos.map(toMachineStatsHourAllOeeTeep);

export const toMachineStatsDayAllOeeTeep = (dto: MachineStatsDayAllOeeTeepDto): MachineStatsDayAllOeeTeep => dto;
export const toMachineStatsDayAllOeeTeeps = (dtos: MachineStatsDayAllOeeTeepDto[]): MachineStatsDayAllOeeTeep[] =>
  dtos.map(toMachineStatsDayAllOeeTeep);

export const toMachineStatsMonthAllOeeTeep = (dto: MachineStatsMonthAllOeeTeepDto): MachineStatsMonthAllOeeTeep => dto;
export const toMachineStatsMonthAllOeeTeeps = (dtos: MachineStatsMonthAllOeeTeepDto[]): MachineStatsMonthAllOeeTeep[] =>
  dtos.map(toMachineStatsMonthAllOeeTeep);

export const toMachineStatsWeekAllOeeTeep = (dto: MachineStatsWeekAllOeeTeepDto): MachineStatsWeekAllOeeTeep => dto;
export const toMachineStatsWeekAllOeeTeeps = (dtos: MachineStatsWeekAllOeeTeepDto[]): MachineStatsWeekAllOeeTeep[] =>
  dtos.map(toMachineStatsWeekAllOeeTeep);
